<template>
	<div class="status-counter-item" :class="[`tone-${tone}`, { active }]" @click="onActive">
		<span class="item-title">{{ title }}</span>
		<span class="item-count">{{ count }}</span>
	</div>
</template>

<script>
import { isMobile } from '@/utils/device'

export default {
	name: 'StatusCounterItem',
	props: {
		id: {
			type: [String, Number],
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		count: {
			type: [String, Number],
			required: true,
		},
		active: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		// 상태 종류별 색 (화면 꾸미기용)
		tone() {
			const key = String(this.id)
			if (key === 'ALL') return 'all'
			if (key.includes('CANCEL')) return 'cancel'
			if (key.includes('WAIT')) return 'wait'
			if (key.includes('APPROVE')) return 'approve'
			if (key.includes('COMPLETE') || key.includes('CONFIRM')) return 'done'
			if (key.includes('SHIPPING')) return 'shipping'
			return 'all'
		},
	},
	watch: {
		// 모바일 칩 탭: 선택한 칩이 화면 안에 보이도록 가운데로 옮긴다
		active(val) {
			if (val) this.scrollIntoChips()
		},
	},
	mounted() {
		if (this.active) {
			this.onActive()
			this.scrollIntoChips()
		}
	},
	methods: {
		scrollIntoChips() {
			if (!isMobile) return
			this.$nextTick(() => {
				if (this.$el && this.$el.scrollIntoView) this.$el.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' })
			})
		},
		onActive() {
			this.$emit('active', this.id)
		},
	},
}
</script>

<style lang="scss" scoped>
.status-counter-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 120px;
	height: 100px;
	background: $HOVER_BACKGROUND;
	border-radius: 16px;
	cursor: pointer;
	span {
		color: $COLOR_666;
	}
	.item-title {
		font-weight: 500;
		font-size: 0.875rem;
		color: $COLOR_999;
	}
	.item-count {
		font-weight: 400;
		font-size: 2rem;
		color: $COLOR_999;
	}
	&.active {
		background: $PRIMARY_BLACK;
		span {
			color: $PRIMARY_WHITE;
		}
		.item-count {
			font-weight: bold;
		}
	}
}
</style>
